import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.cancel';

const LABELS = makeLabels(
  {
    HEADER: ['header', 'Cancel Payout'],
    ACTION_LABEL: ['actionLabel', 'Cancel Transaction'],
    GENERIC_CANCELLATION_ERROR: ['genericCancellationError', 'An error occurred while cancelling the payout. Please try again later.'],
  },
  NAMESPACE,
);

export default LABELS;
